export default __webpack_public_path__ + "static/media/elephant.781f39d0.svg";